import { render, staticRenderFns } from "./IconPerfomance.vue?vue&type=template&id=1538640e&scoped=true&"
import script from "./IconPerfomance.vue?vue&type=script&lang=js&"
export * from "./IconPerfomance.vue?vue&type=script&lang=js&"
import style0 from "./IconPerfomance.vue?vue&type=style&index=0&id=1538640e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538640e",
  null
  
)

export default component.exports